import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { startsWith } from "lodash";

import {
  getCounterForChat,
  getComposingHomie,
  isMuted,
} from "selectors/chat/chat";
import ChatImage from "../shared/ChatImage";
import Notification from "../shared/Notification";
import Composing from "../shared/Composing";
import Muted from "../shared/Muted";
import { createAttachmentQuoteText } from "helpers/chat/attachmentUtils";
import { AttachmentType } from "components/chat/ChatRoom/ChatMessage";
import formatDate, { formatDateFromNow } from "helpers/formatDate";

export default function Row({
  id,
  name,
  last_message,
  last_interacted_at,
  state,
}: {
  id: string;
  name: string;
  last_message: {
    from: { name: string };
    text: string;
    deleted_at: string | null;
    files: AttachmentType[];
    images: AttachmentType[];
  };
  last_interacted_at: string;
  state: { last_read_id: string | null; last_message_id: string | null };
}) {
  const dispatch = useDispatch();
  const type = startsWith(id, "member") ? "member" : "group";
  const counter = useSelector((state) =>
    getCounterForChat(state, { chatId: id }),
  );
  const muted = useSelector((state) => isMuted(state, { chatId: id }));
  const composingHomie = useSelector((state) =>
    getComposingHomie(state, { chatId: id }),
  );

  function select() {
    dispatch({
      type: "chat/NAVIGATE",
      payload: { route: "showChat", params: { chatId: id } },
    });

    if (window.Notification && window.Notification.permission !== "granted") {
      window.Notification.requestPermission();
    }
  }

  return (
    <div className="chat__list_row" onClick={select} title={name}>
      <div className="grid stack-container shrink-0">
        <ChatImage chatId={id} name={name} />
        <Notification
          counter={state?.last_read_id ? counter : -1}
          className="stack-item w-fit h-fit z-50 justify-self-end"
        />
        {composingHomie && (
          <Composing className="stack-item z-50 justify-self-end self-end" />
        )}
        {muted ? <Muted /> : null}
      </div>
      <div className="chatButtonElement texts grow truncate">
        <div className="chatName truncate font-semibold leading-tight">
          {name}
        </div>
        {last_message ? (
          <div className="chatTeaser text-xs text-muted truncate">
            {type === "group" ? <span>{last_message.from.name}: </span> : null}
            {last_message.deleted_at ? (
              <span className="italic">
                {I18n.t("js.chat.room.message.deleted_message.text")}
              </span>
            ) : (
              last_message.text || createAttachmentQuoteText(last_message)
            )}
          </div>
        ) : null}
      </div>
      <div className="chatButtonElement chatLastInteraction text-xs text-muted shrink-0">
        {last_interacted_at && (
          <time
            title={formatDate(new Date(last_interacted_at), "dd.MM.y HH:mm")}
          >
            {I18n.t("js.chat.list.last_interacted_at.label", {
              date: formatDateFromNow(new Date(last_interacted_at)),
            })}
          </time>
        )}
      </div>
      <i className="fa fa-chevron-right chatButtonElement openChatIcon" />
    </div>
  );
}
